module.exports = __webpack_public_path__ + "img/4.6407b865.jpg";